var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4721 8.83984C4.351 8.83984 4.9587 9.15625 5.22991 9.34208C5.32533 9.3923 5.57645 9.54799 5.64174 9.56306V1.21596C5.26507 0.563058 4.23549 0.0507812 3.18583 0.0507812C1.79464 0.0507812 0.659598 0.834263 0.363281 1.4269V9.01562C0.368304 9.46261 0.61942 9.64342 0.930804 9.64342C1.16183 9.64342 1.30748 9.56306 1.46317 9.44252C1.7846 9.18136 2.52288 8.83984 3.4721 8.83984ZM8.52455 8.83984C9.47377 8.83984 10.207 9.18136 10.5285 9.44252C10.6842 9.56306 10.8298 9.64342 11.0558 9.64342C11.3672 9.64342 11.6283 9.46261 11.6283 9.01562V1.4269C11.332 0.834263 10.197 0.0507812 8.81083 0.0507812C7.76116 0.0507812 6.72656 0.563058 6.35491 1.21596V9.5731C6.41518 9.55804 6.66629 9.39732 6.76674 9.34208C7.03795 9.15625 7.64565 8.83984 8.52455 8.83984Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.a327af8c1ea1ef562541a6dcaf5c4be2.svg";
export { ForwardRef as ReactComponent };